module.exports = __webpack_public_path__ + "static/media/dearStudent.33ba6c3.aac";


//////////////////
// WEBPACK FOOTER
// ./static/music/dearStudent.aac
// module id = cs9e
// module chunks = 1